import FormRow from 'Components/FormRow';
import InputHandler from 'Components/InputHandler';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';

const optionFormatter =
  (opt: number | string) =>
  (name: number | string): React.JSX.Element => <FormattedMessage id={`clinicalstudy.${opt}.${name}`} />;

const OCTSCANForm = ({ formData }: IOwnProps): React.JSX.Element => (
  <React.Fragment>
    <FormRow title="general.date">
      <InputHandler
        type="PartialDate"
        editing={true}
        name="date"
        formData={formData}
        dateDefault="now"
        isNotCancellable={true}
      />
    </FormRow>
    <FormRow title="clinicalstudy.result">
      <InputHandler
        type="Radio"
        editing={true}
        name="result"
        formData={formData}
        options={['normal', 'abnormal']}
        optionFormatter={optionFormatter('opts.normalAbnormal')}
      />
    </FormRow>
  </React.Fragment>
);

interface IOwnProps {
  formData: IFormData<IDocumentWithTypeV2<'octscan'>>;
}

export default OCTSCANForm;
